<template>          
  <v-container fluid class="signup">
    <div class='pattern'></div>
    
    <v-layout align-center justify-center row fill-height>
        <v-flex class="divlogin" xs12 sm12 md10 lg6>     
        <v-form v-model="valid" class="formlogin" style="background-color:#263971; border-radius:20px">          
          <v-layout row wrap align-center justify-center class="pa-5 my-2">
            <v-flex xs12 sm12 md12 lg12>
              <h1>{{title}}</h1>
              <h3>{{message}}</h3>
            </v-flex>
            <v-flex xs12 sm12 md12 lg12>
              <v-flex class="my-5" xs12 md4 lg5>   
                <v-text-field
                        v-model="password"
                        :append-icon="show2 ? 'visibility' : 'visibility_off'"
                        :rules="[rules.required]"
                        :type="show2 ? 'text' : 'password'"
                        name="input-10-2"
                        label="Contraseña"
                        style="background:white; border-radius:8px;"
                        hint="At least 8 characters"
                        solo
                        prepend-inner-icon="lock"
                        flat
                        class="input-group--focused my-3 pa-1"
                        @click:append="show2 = !show2"                        
                ></v-text-field>
            
            <v-text-field
                        v-model="password2"
                        :append-icon="show2 ? 'visibility' : 'visibility_off'"
                        :rules="[rules.required]"
                        :type="show2 ? 'text' : 'password'"
                        name="input-10-2"
                        label="Contraseña"
                        style="background:white; border-radius:8px;"
                        hint="At least 8 characters"
                        solo
                        prepend-inner-icon="lock"
                        flat
                        class="input-group--focused my-3 pa-1"
                        @click:append="show2 = !show2"                        
                      ></v-text-field>                    
                  </v-flex>
            </v-flex>
            <v-flex xs12 sm12 md4 lg5>   
              <v-btn
                  large                  
                  class="text-none loginbutton"
                  color="#4ba96c"
                  dark
                  @click="verifyempty()"
                >
                  Enviar
                </v-btn>
            </v-flex>
          </v-layout>  
        </v-form>
        </v-flex>      
    </v-layout>
    
    </v-container>
</template>

<script>



export default {    
    data () {
      return {
        title:"Restablecer contraseña",
        message:"Introduzca la nueva contraseña para su usuario",
        valid:false,
        show2: false,    
        rules: {
          required: value => !!value || 'Obligatorio',          
        },
        password:'',
        password2:'',
      }
    },
    mounted(){
        if (this.isEmpty(this.$route.query)) {
            this.$router.push('login')
        }
    },
    methods:{
        verifyempty: function(){
            if(this.password==""||this.password2==""){
                this.message="El campo no puede estar vacio"
            }else if(this.password!=this.password2){
                this.message="Las contraseñas deben coincidir"
            }else if(this.password==this.password2){

                var token = this.$route.query.id
                var pass = this.password
                this.$store.dispatch('reset_password', {pass,token})
                .then((value) =>
                    {
                        if (value == 200) {
                            this.message="Se ha restaurado su contraseña"  
                            this.$router.push('/login')
                        }else if(value == 400){
                          this.message="Hubo un problema al restaurar su contraseña"
                        }else{
                            this.message="Hubo un problema al restaurar su contraseña"
                        }
                    }
                ).catch( () => {
                    {this.message="Hubo un problema al completar la solicitud intentelo de nuevo mas tarde";}
                })          
            }
        },
        isEmpty(obj) {
            for(var prop in obj) {
                if(obj.hasOwnProperty(prop)) {
                    return false;
                }
            }
            return JSON.stringify(obj) === JSON.stringify({});
        }
    }
    
}
</script>


<style>
h1,h3 {
    color: aliceblue
}
.signup {
  text-align: left;
  z-index: 1;
  background-color:#2F478D;;
}

.signup img{
    z-index: 2;
}

.theme--light.v-icon{
  color:#B4347E;
}
</style>